import { render, staticRenderFns } from "./TabPresentials.vue?vue&type=template&id=597d9cdd&"
import script from "./TabPresentials.vue?vue&type=script&lang=js&"
export * from "./TabPresentials.vue?vue&type=script&lang=js&"
import style0 from "./TabPresentials.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabPresentials.vue"
export default component.exports